import * as Icon from "react-bootstrap-icons";
import TextSimpleInput from "../../FormElements/TextSimpleInput";
import {useEffect, useState} from "react";
import {ChangeEvent} from "react";

export default function Artikelzeile(props) {

    const Items = JSON.parse(localStorage.getItem('items'));
    const itemVariants = JSON.parse(localStorage.getItem('itemVariants'));
    const [selectedId, setSelectedId] = useState(Items[0]['No_']);
    const palettenTypen = ['Epal', 'Vpal','DuPal', 'Fremdpalette'];
    const preisTypen = {2: 'Kundenpreisliste', 0: 'Kundenpreis', 1: 'Erzeugerpreis'};
    const [preisProEinheitRequired, setPreisProEinheitRequired] = useState(true);
    const errorMessages = {
        leergut: 'Bitte geben Sie Infos zum Leergut an.',
    }


    function checkPreisType(event) {
        if (2 === event.target.value) {
        setPreisProEinheitRequired(false);
        } else {
            setPreisProEinheitRequired(true);
        }

    }

    const handleArtikelChange =(e: ChangeEvent<HTMLSelectElement>) => {
        const selectedOption = e.target.selectedOptions[0];
        setSelectedId(selectedOption.dataset.id ?? "");
    }

    useEffect(() => {
        if (props.values && props.values.artikel.length >0) {
            setSelectedId(document.getElementById("s" + props.idx).selectedOptions[0].dataset.id);
        }
    }, []);

    return (
        <tr id={props.idx}>
            <td>
                <select id={"s" + props.idx} className="form-select-sm" name="artikel[]"  onChange={handleArtikelChange}>
                    {Items.map((item) => {
                        return (<option key={item.No_} value={item.description} data-id={item.No_}
                                        selected={props.values && props.values.artikel === item.description}>{item.description}</option>)
                    })}
                </select>
            </td>
            <td>
                <select className="form-select-sm" name="artikelSorte[]">
                    {Object.entries(itemVariants).map(([key, values]) =>
                        values.map((value) => (selectedId && selectedId === key &&
                            <option key={`${key}-${value}`} value={value} data-id={key} selected={props.values && props.values.sorte === value}>
                                {value}
                            </option>
                        ))
                    )
                }
                </select>
            </td>
            <td>
                <TextSimpleInput type="text"  name="artikelZusatz[]" required={false}
                                  defaultValue={props.values && props.values.artikelZusatz}/>
            </td>
            <td>
                <TextSimpleInput type="text"  name="artikelBemerkung[]" required={false}
                                 defaultValue={props.values && props.values.artikelBemerkung}/>
            </td>
            <td>
                <TextSimpleInput type="text" placeholder="ELK" name="leergut[]" required={true}
                                 invalidMessage={errorMessages.leergut} defaultValue={props.values && props.values.leergut}/>
            </td>
            <td>
                <TextSimpleInput type="text" name="verpackung[]" placeholder="10 x 500g Folie" required={true}
                                 invalidMessage={errorMessages.verpackung} style={{width: '140px'}}
                                 defaultValue={props.values && props.values.verpackung}/>
            </td>
            <td>
                <TextSimpleInput type="text" name="kollimenge[]" placeholder="4" required={true}
                                 invalidMessage={errorMessages.kollimenge}/>
            </td>
            <td>
                <TextSimpleInput type="text" name="palettenmenge[]" placeholder="-" required={true}
                                 invalidMessage={errorMessages.palettenmenge}/>
            </td>
            <td>
                <select name="palettentyp[]">
                    {palettenTypen.map((pTyp) => {
                        return <option key={pTyp} value={pTyp}
                                       selected={props.values && props.values.palettentyp === pTyp}>{pTyp}</option>
                    })}
                </select>
            </td>
            <td>
                <TextSimpleInput type="text" name="kolliProPalette[]" placeholder="" required={false}
                                 defaultValue={props.values && props.values.kolli_pro_palette}/>
            </td>
            <td>
                <TextSimpleInput type="text" name="preisKg[]" placeholder="X,xx" required={preisProEinheitRequired}
                                 invalidMessage={errorMessages.preisKg}
                                 defaultValue={props.values && props.values.preis_einheit}/>
            </td>
            <td>
                <TextSimpleInput type="text" name="preisEh[]" placeholder="kg/stk" required={true}
                                 invalidMessage={errorMessages.preisEh}
                                 defaultValue={props.values && props.values.preis_pro_einheit}/>
            </td>
            <td>
                <select name="preisTyp[]" onChange={checkPreisType}>
                    <option value="">Bitte auswählen</option>
                    {Object.keys(preisTypen).map((pTyp) => {
                        return <option key={pTyp} value={pTyp}
                                       selected={props.values && props.values.preis_typ === pTyp}>{preisTypen[pTyp]}</option>
                    })}
                </select>
            </td>
            <td>
                <button className="btn btn-secondary btn-sm" type="button" onClick={() => {
                    props.handler(props.idx);
                }}>
                    <Icon.PatchMinus/>
                </button>
            </td>
        </tr>
    )
}